import { ReactElement } from 'react'

import { Carat, RotateClockwise } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'

import { Back, Next } from './styles'
import { useUpsellsCarousel } from './UpsellsCarouselContext'

export const CarouselControls = (): ReactElement => {
  const { isBeginning, isEnd, swiperRef } = useUpsellsCarousel()
  const {
    cart: {
      upsell: {
        accessibility: { carouselBackButton, carouselNextButton },
      },
    },
  } = useTranslation()

  return (
    <>
      <Back
        aria-disabled={isBeginning}
        onClick={() => {
          if (isBeginning) return
          swiperRef.current?.slidePrev()
        }}
        aria-label={carouselBackButton}
      >
        <Carat rotateClockwise={RotateClockwise.Half} />
      </Back>
      <Next
        aria-disabled={isEnd}
        onClick={() => {
          if (isEnd) return
          swiperRef.current?.slideNext()
        }}
        aria-label={carouselNextButton}
      >
        <Carat />
      </Next>
    </>
  )
}
